import React, { useState, useEffect } from "react";
import Logo from "../images/logo.svg";
import Sidebar from "../component/Sidebar";
import { Timeline, Whisper, Tooltip, SelectPicker } from "rsuite";
import "rsuite/dist/rsuite.min.css";
import IconHistory from "../images/history.svg";
import "../css/InvestDetails.css";

function InvestDetails() {
  const [tabName, setTabName] = useState("Timeline");
  useEffect(() => {
    document.title = tabName;
  }, [tabName]);

  const [searchInput, setSearchInput] = useState("");
  const [statusId, setStatusId] = useState(null);
  const [countryCode, setCountryCode] = useState(null);
  const [complianceId, setComplianceId] = useState(null);

  const handleSearch = (e) => setSearchInput(e.target.value);
  const handleClearFilters = () => {
    setSearchInput("");
    setStatusId(null);
    setCountryCode(null);
    setComplianceId(null);
  };

  const timelineData = [
    {
      date: "March 1, 10:20",
      status: "Investor Joined",
      description: "The investor has joined the platform.",
    },
    {
      date: "March 2, 12:00",
      status: "Investment Made",
      description: "The investor made an investment of $1,000.",
    },
    {
      date: "March 3, 14:45",
      status: "Email ID Changed",
      description: "The investor updated their email ID.",
    },
    {
      date: "March 5, 16:30",
      status: "Profile Updated",
      description: "Investor updated personal info.",
    },
    {
      date: "March 7, 11:00",
      status: "Investment Confirmed",
      description: "Investor confirmed the investment.",
    },
    {
      date: "March 9, 13:15",
      status: "Investment Withdrawn",
      description: "Investor withdrew $500.",
    },
    {
      date: "March 10, 09:50",
      status: "Reallocation",
      description: "Funds reallocated to different assets.",
    },
    {
      date: "March 12, 17:00",
      status: "Account Locked",
      description: "Temporarily locked for security.",
    },
    {
      date: "March 15, 18:45",
      status: "Account Unlocked",
      description: "Verified and unlocked.",
    },
    {
      date: "March 20, 10:30",
      status: "Withdraw Processed",
      description: "Withdrawal successfully processed.",
    },
    {
      date: "March 22, 15:00",
      status: "Withdrawal Confirmed",
      description: "Confirmed withdrawal of $500.",
    },
  ];

  const [assignedUsers, setAssignedUsers] = useState([
    { label: "Zain Shaikh", value: "zain_shaikh" },
    { label: "Sarah Johnson", value: "sarah_johnson" },
    { label: "Michael Brown", value: "michael_brown" },
    { label: "Emma Wilson", value: "emma_wilson" },
  ]);

  const [statusOptions, setStatusOptions] = useState([
    { label: "Funded", value: "funded" },
    { label: "Pending", value: "pending" },
    { label: "Approved", value: "approved" },
    { label: "Rejected", value: "rejected" },
    { label: "On Hold", value: "on_hold" },
  ]);

  const [investorData, setInvestorData] = useState({
    name: "Ahmed Khan",
    id: "INV-100245",
    email: "ahmed.khan@email.com",
    phone: "+971501234567",
    country: "UAE",
    investmentAmount: 25000,
    shares: 12500,
    investorType: "Corporation",
    dateOfInvestment: "09 May 2025",
    investmentType: "Paid",
    joiningDate: "01 Apr 2025",
    plan: "Premium",
    status: "funded",
    assignedUser: "zain_shaikh",
    totalInvested: 12500,
    currentValue: 14200,
    activeInvestments: 3,
    completedInvestments: 2,
    riskProfile: "Moderate",
    preferredSectors: ["Technology", "Real Estate"],
    kycStatus: "Verified",
    lastActivity: "Today, 10:30 AM",
    address: "Dubai, UAE",
  });

  const handleStatusChange = (value) => {
    setInvestorData((prev) => ({ ...prev, status: value }));
  };

  const handleAssignedUserChange = (value) => {
    setInvestorData((prev) => ({ ...prev, assignedUser: value }));
  };

  return (
    <>
      <Sidebar />
      <div
        id="header"
        style={{
          position: "sticky",
          top: 0,
          zIndex: 1000,
          backgroundColor: "#fff",
          padding: "10px 20px",
          borderBottom: "1px solid #ddd",
        }}
      >
        <div className="logo">
          <div className="logo_icon">
            <img src={Logo} alt="Logo" />
          </div>
          <div className="brand_name">Timeline</div>
        </div>

        <div className="header_table_filter">
          <div className="searchfield">
            <button className="btn_search">
              <i className="icon-search2"></i>
            </button>
            <input
              type="text"
              className="filter_searchfield"
              placeholder="Search"
              autoComplete="off"
              onChange={handleSearch}
              value={searchInput}
            />
          </div>

          <a
            href="#"
            className="btn_clear_filter"
            style={{ textDecoration: "none" }}
            onClick={handleClearFilters}
          >
            Clear Filters
          </a>
        </div>
      </div>

      <div className="container-fluid investor-details-container">
        <div className="row">
          {/* Investor Profile Card */}
          <div className="col-12 col-md-7 mb-4">
            <div className="investor-card">
              <div className="investor-header">
                <div className="investor-avatar">
                  {investorData.name.charAt(0)}
                </div>
                <div className="investor-title">
                  <h2>{investorData.name}</h2>
                  <span className="investor-id">{investorData.id}</span>
                </div>
              </div>

              <div className="investor-stats">
                <div className="stat-item">
                  <div className="stat-label">Total Invested</div>
                  <div className="stat-value">
                    ${investorData.totalInvested.toLocaleString()}
                  </div>
                </div>
                <div className="stat-item">
                  <div className="stat-label">Current Value</div>
                  <div className="stat-value">
                    ${investorData.currentValue.toLocaleString()}
                  </div>
                </div>
                <div className="stat-item">
                  <div className="stat-label">Active Investments</div>
                  <div className="stat-value">
                    {investorData.activeInvestments}
                  </div>
                </div>
              </div>

              <div className="investor-details">
                {/* Contact Info */}
                <div className="detail-row">
                  <span className="detail-label">Email :</span>
                  <span className="detail-value">{investorData.email}</span>
                </div>
                <div className="detail-row">
                  <span className="detail-label">Phone :</span>
                  <span className="detail-value">{investorData.phone}</span>
                </div>
                <div className="detail-row">
                  <span className="detail-label">Country :</span>
                  <span className="detail-value">{investorData.country}</span>
                </div>
                <div className="detail-row">
                  <span className="detail-label">Type :</span>
                  <span className="detail-value">
                    {investorData.investmentType}
                  </span>
                </div>
                <div className="detail-row">
                  <span className="detail-label">Investment Amount :</span>
                  <span className="detail-value">
                    ${investorData.investmentAmount.toLocaleString()}
                  </span>
                </div>
                <div className="detail-row">
                  <span className="detail-label">Shares :</span>
                  <span className="detail-value">
                    {investorData.shares.toLocaleString()}
                  </span>
                </div>
                <div className="detail-row">
                  <span className="detail-label">Investor Type :</span>
                  <span className="detail-value">
                    {investorData.investorType}
                  </span>
                </div>
                <div className="detail-row">
                  <span className="detail-label">Date of Investment :</span>
                  <span className="detail-value">
                    {investorData.dateOfInvestment}
                  </span>
                </div>
                <div className="detail-row">
                  <span className="detail-label">Joining Date :</span>
                  <span className="detail-value">
                    {investorData.joiningDate}
                  </span>
                </div>
                <div className="detail-row">
                  <span className="detail-label">Plan :</span>
                  <span className="detail-value">{investorData.plan}</span>
                </div>
                <div className="detail-row">
                  <span className="detail-label">Status :</span>
                  <div className="detail-value">
                    <SelectPicker
                      data={statusOptions}
                      value={investorData.status}
                      onChange={handleStatusChange}
                      style={{ width: 150 }}
                      cleanable={false}
                      placement="topStart"
                      container={() => document.body}
                    />
                  </div>
                </div>
                <div className="detail-row">
                  <span className="detail-label">Assigned User :</span>
                  <div className="detail-value">
                    <SelectPicker
                      data={assignedUsers}
                      value={investorData.assignedUser}
                      onChange={handleAssignedUserChange}
                      style={{ width: 200 }}
                      cleanable={false}
                      container={() => document.body}
                      placement="topStart"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Investment Summary + Timeline */}
          <div className="col-12 col-md-5 pt-3">
            <div className="timeline-container">
              <h3 className="timeline-header">Investment Summary</h3>
              <table className="table table-bordered mb-4">
                <tbody>
                  <tr>
                    <th>Total Invested</th>
                    <td>${investorData.totalInvested.toLocaleString()}</td>
                  </tr>
                  <tr>
                    <th>Total Shares</th>
                    <td>{investorData.shares.toLocaleString()}</td>
                  </tr>
                  <tr>
                    <th>Currency</th>
                    <td>AED</td>
                  </tr>
                  <tr>
                    <th>Average Investment</th>
                    <td>
                      ${(
                        investorData.totalInvested /
                        investorData.activeInvestments
                      ).toLocaleString()}
                    </td>
                  </tr>
                  <tr>
                    <th>First Investment</th>
                    <td>01 Apr 2025</td>
                  </tr>
                  <tr>
                    <th>Latest Investment</th>
                    <td>{investorData.dateOfInvestment}</td>
                  </tr>
                  <tr>
                    <th>Rounds Joined</th>
                    <td>Seed 2025, Growth 2024</td>
                  </tr>
                </tbody>
              </table>

              <h3 className="timeline-header">Recent Activity</h3>
              <Timeline className="custom-timeline">
                {timelineData.map((item, index) => (
                  <Timeline.Item
                    key={index}
                    dot={
                      <img
                        src={IconHistory}
                        alt="history"
                        style={{ width: 20, height: 20 }}
                      />
                    }
                  >
                    <div className="timeline-card">
                      <div className="timeline-arrow" />
                      <div className="timeline-date">{item.date}</div>
                      <div className="timeline-status">{item.status}</div>
                      <div className="timeline-description">
                        {item.description}
                      </div>
                    </div>
                  </Timeline.Item>
                ))}
              </Timeline>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default InvestDetails;
